import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { useToast } from "vue-toastification";
import { ModelosVehiculoInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculo.interface";
import { ModeloVehiculoCreateAction } from "../../actions/modeloVehiculoActions";
import { ModeloVehiculoCreateInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculoCreate.interface";

const toast = useToast();

export function useModeloVehiculoCreate(onClose?: () => void) {
  const queryClient = useQueryClient();

  // Mutation para crear el modelo de vehÃ­culo
  const mutation = useMutation({
    mutationFn: (Modelo: ModeloVehiculoCreateInterface) =>
      ModeloVehiculoCreateAction(Modelo),

    onSuccess: async (response: ApiResponse<ModelosVehiculoInterface>) => {
      await queryClient.invalidateQueries({
        queryKey: ["ModeloVehiculosList"],
      });
      await queryClient.refetchQueries({
        queryKey: ["MarcaModeloList"],
        exact: true,
      });
      toast.success("Modelo de vehÃ­culo creado correctamente");
      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al crear modelo de vehÃ­culo");
      if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
